import { createWebHistory, createRouter } from 'vue-router'
import routes from "./routes";
// import axios from 'axios'

const router = createRouter({
  // 路由的模式
  history: createWebHistory(),
  // 路由规则
  routes,
  //滚动行为
})
export default router